import React from "react";
import  { useState, useEffect } from 'react';
import './classes/FootballEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const FootballEducationProgram = () => {

    // const navigate = useNavigate();
   const app_url = configData.APP_URL;
   const [isLoading, setIsLoading] = useState(true);
   const [mentors, setMentors] = useState([]);
   const [courseTopics, setCourseTopics] = useState([]);
   const [conferences, setConferences] = useState([]);
   const [courses, setCourses] = useState([]);

    useEffect(() => {
        const mentors = [
             {
                name: "Aaron Schatz",
                image: "/basic/web/images/scout/AaronSchatz.png",
                description: ` is the creator of Football Outsiders and most of the original statistical methods used in NFL analysis, as well as lead writer, editor, and statistician on the book series Football Outsiders Almanac. He also writes for ESPN.com and ESPN The Magazine and is the main analyst for the ESPN Fantasy Football Weekly podcast. During the 2011 season, he was a regular panelist on the ESPN2 show Numbers Never* Lie. Before Football Outsiders, Aaron spent five years on the radio at WBRU Providence and WKRO Daytona Beach, and three years as the writer and producer of the Lycos 50, the Internet's foremost authority on the people, places, and things that are searched online. He has written for a number of publications including The New Republic, The New York Times, The Boston Globe, Slate, The American Prospect, and the Boston Phoenix.`,
               
             },
             {
                name: "Mike Tanier",
                image: "/basic/web/images/scout/miketanier_0.jpg",
                description: ` taught mathematics in the New Jersey public school system for 17 years before embarking on a full-time sports-writing career. Starting at Football Outsiders while still a teacher, he became the Sunday NFL preview writer for the New York Times, mixing stats and analysis with off-the-wall humor. After several years at the Times, Tanier spent two years as the primary NFL writer for Sports on Earth. He's now an NFL Lead Writer for Bleacher Report, sometime Football Outsiders contributor, author of two sports books, father of two, and America's poet laureate of Jay Cutler jokes.`,
               
             },
             {
                name: "Russ Lande,",
                image: "/basic/web/images/scout/Russ_Lande_Headshot.jpg",
                description: ` is currently a Sporting News.com NFL Draft Expert and President and Founder of GMJR.com. For the Sporting News, Lande is responsible for writing NFL insider content, providing detailed scouting reports on college players and posting an ongoing mock draft in the “War Room” leading up to the NFL Draft. Before working for Sporting News, Lande served as a college scout for the Cleveland Browns for three years covering the mid-west region while evaluating all eligible prospects for the NFL Draft. He covers all-star games, the NFL Combine and pro days. Lande continues to appear on radio stations across the country. Lande is also the author of the annual "GM Jr Draft Guide" which has been called the most comprehensive, unique and thorough NFL Draft Guide ever written and made available to the fans and scouts of the NFL.`,
                
            },
             {
                name: "John Wooten,",
                image: "/basic/web/images/scout/jwooten_collage.jpg",
                description: ` has been involved with the NFL for 44 years first as a player for the Cleveland Browns from 1959-1967 and then the Washington Redskins from 1967-1968. Following his playing career, he was Director of Pro Sports Advisors (Agent for Professional Athletes - 1973-1975); Player Personnel (Cowboys - 1975-1991); Director of Pro Personnel (Cowboys 1980-1991); Creator/Director of Player Programs (NFL - 1991 - 1992 (developing programs for Continuing Education, Financial Assistance, Family Assistance, Internship for NFL Players; Player Personnel (Eagles 1992-1993); Vice President Player Personnel (Eagles 1994-1997); Assistant Director of Pro/College Scouting (Ravens 1998-2001), Consultant-Player Personnel (Ravens - 2001 until he retired in 2004).`,
                
                
            },
             {
                name: "Mark Dominik",
                image: "/basic/web/images/scout/picture-1966-1441815855.jpg",
                description: ` joined the Tampa Bay Buccaneers staff at just 24 years old as a pro personnel assistant and worked his way up the ladder to general manager while contributing to seven playoff teams and a Super Bowl championship. After leaving the Buccaneers in 2013, Dominik began working for ESPN as an analyst, adding a media perspective to his experience operating a team.`,
                
            },
        ];
        setMentors(mentors);

        const courseTopics = [
            "Football Scouting player evaluation; body type, mental makeup, playing ability, physical tools",
            "Learn to identify players who will succeed at NFL level",
            "College Scouting and rating college talent as it pertains to the NFL draft",
            "Traditional Football scouting vs. new high tech scouting",
            "Techniques to evaluating the college all star games",
            "Combine evaluation; Shuttle, Vertical Jump, L-Cone, Forty & Broad Jump",
            "The making of a football scouting report",
            "The language of football scouting including Offense and Defense analyses.",
            ];
        setCourseTopics(courseTopics);
           const courseData = [
      {
        title: "Football General Manager and Scouting",
        link: `${configData.DRUPAL_DOMAIN_URL}/courses/football-gm-scouting`,
        image: "/basic/web/images/scout/markdominick_0_0.jpg",
        mobileIcon: "/basic/web/images/scout/Football_gm.png",
        description:
          "Learn NFL scouting from scouts who do the hiring. Write defensive/offensive scouting reports corrected by current scouts. NFL's talent ...",
        month: "December",
        day: "1",
        fullDate: "December 1",
      },
      {
        title: "Football Agent Certification Prep",
        link: `${configData.DRUPAL_DOMAIN_URL}/courses/football-agent-certification-prep-course`,
        image: "/basic/web/images/scout/joelcorry.jpg",
        mobileIcon: "/basic/web/images/scout/NFLPA_0.png",
        description:
          "8-week online NFLPA Certification Prep Course offers additional study preparation for the NFLPA Certification exam.",
        month: "Starts",
        day: "Soon",
        fullDate: "Soon",
      },
    ];

    setCourses(courseData);
 

   const conferences = [
        {
            title: "Football Career Conference during the NFL Combine",
            description:
            "Network & meet NFL Scouts, Agents, Player Personnel, Media, and Management. Career guidance from those who do the hiring.Our annual ...",
            location: "Indianapolis, Indiana",

            //  Desktop structure fields
            month: "February",
            day: "27",
            year: "2026",
            fullDate: "December 8, 2025", // for mobile layout

            image:
            "/basic/web/images/scout/football_conference_tile_image.jpg",
            icon:
            "/basic/web/images/scout/football_conference_tile_image.jpg",
            link: `${configData.DRUPAL_DOMAIN_URL}/conferences/nfl-combine-sports-career-conference`,
        },
];

    setConferences(conferences);

          

    },[]);

    useEffect(() => {
        Promise.all([
             
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
     
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" className="football-education-program-main">
                <Helmet><title>Football Scout Education</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                   <div className="football-education-program-container">
                    <div className="scouting-mentors">                        
                            <h1>SMWW American Football Education Program</h1>
                            <p>SMWW Football Scouts have been trained and mentored by some of the best in the industry. SMWW Football Scouts have completed a rigorous eight week training program and instructed by Russ Lande, John Wooten, Aaron Schatz and Mike Tanier. SMWW Football Scouts are listed here with scouting report samples. Please contact them and arrange a complimentary scouting report for your program, be it at the high school, university, or professional level.</p>
                            <h2>SMWW Football Scouting Mentors:</h2>
                             {mentors.map((mentor,index) => (
                                <div className="scout-mentors" key={mentor.name} style={{ marginBottom: "1.5rem", overflow: "auto" }}>
                                <img
                                    src={mentor.image}
                                    alt={mentor.name}
                                    className={`mentor-image mentor-image-${index}`}
                                />
                                <p>
                                    <strong>{mentor.name}</strong> {mentor.description}
                                </p>
                                </div>
                            ))}
                            <h2>SMWW Football Scouts have successfully completed 8 weeks of training including:</h2>
                                <ul>
                                    {courseTopics.map((topic, index) => (
                                    <li key={index}>{topic}</li>
                                    ))}
                                </ul>
                               <div style={{ clear: "both", textAlign: "center", marginBottom: "10px" }}>
                                <a className="reddbtnn" href={`https://${configData.RSMWW_DOMAIN}/application`}>
                                Apply today for training as an SMWW Certified Football Scout
                                </a>
                               </div>
                            <p>
                                <p>&nbsp;</p>
                            <span><strong><a href="/scout-sports/football">Click here</a>  to search for a SMWW Football Scout by Area.  </strong><br/>
                            SMWW Scouts will do a complimentary scouting report to your specifications to prove they are an expert.</span></p>
                            <p><strong><em>SMWW Scouts will be an exceptional resource to save you time and money in your program!</em></strong></p>
                    </div>
                    {/* 8 week courses and certificates block */}
                   <div id="conferences-block" className="conferences-block">
                    <h2>8-Week Courses & Certificates <span style={{ fontWeight: "normal" }}>(Alphabetical)</span>:</h2>

                    <div className="view-conferences">
                        <ul className="colistitem">
                            {courses.map((course, index) => (
                                <li className="views-row" key={index} course={course}>
                                    <div className="views-field">

                                        {/* ---------------- Desktop Tile (matching conference structure) ---------------- */}
                                        <div className="desktop_conference_tile">

                                            <div className="views-field-field-image">
                                                <a href={course.link}>
                                                    <img src={course.image} alt={course.title} />
                                                </a>
                                            </div>

                                            <div className="views-field-wrap">
                                                <div className="views-field-title">
                                                    <a href={course.link}>{course.title}</a>
                                                </div>

                                                <div className="views-field-field-apply-form-desc intro">
                                                    {course.description}
                                                </div>

                                                <div className="views-field-field_location">
                                                    {/* <span>Starts Online</span> */}
                                                </div>
                                            </div>

                                        <div
                                        className={
                                            `views-field views-field-field-registration-deadline-day 
                                            ${course.month === "Starts" && course.day === "Soon" ? "starts-soon-block" : ""}`
                                        }
                                        >
                                        <div className="rdt">
                                            <span className={`a1 ${course.month === "Starts" && course.day === "Soon" ? "starts-soon-month" : ""}`}>
                                            {course.month}
                                            </span>

                                            <span className={`a2 ${course.month === "Starts" && course.day === "Soon" ? "starts-soon-day" : ""}`}>
                                            {course.day}
                                            <span className="view-field-year">{course.year}</span>
                                            </span>

                                            {/* Hide "Course Start Date" for this course */}
                                            {!(course.month === "Starts" && course.day === "Soon") && (
                                            <>
                                                <span className="a3">Course</span>
                                                <span className="a4">Start Date</span>
                                            </>
                                            )}
                                        </div>

                                        <div className="rbt">
                                            <a href={course.link}>                                           
                                            <span class="a1">LEARN MORE AND</span>
                                            <span class="a2 apply">APPLY</span></a>                                           
                                        </div>
                                        </div>



                                        </div>

                                        {/* ---------------- Mobile Tile (matching conference structure) ---------------- */}
                                        <div className="mobile_conference_tile">

                                            <div className="views-field-wrap">
                                                <div className="header_title_div">
                                                    <div className="circle_image">
                                                        <i>
                                                            <img src={course.mobileIcon} alt="" />
                                                        </i>
                                                    </div>

                                                    <div className="views-field-title title">
                                                        <a href={course.link}>{course.title}</a>
                                                    </div>
                                                </div>

                                                <div className="rdt">
                                                    <div className="month_day">
                                                        Starts {course.fullDate}
                                                    </div>

                                                    {/* <div className="starts">Online</div> */}

                                                    <div className="description">{course.description}</div>

                                                    <div style={{ paddingBottom: "8%", paddingTop: "8%" }}>
                                                        <span className="learn-more-btn">
                                                            <a href={course.link}>LEARN MORE</a>
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                    {/* 8 week courses and certificates block */}
                    <div id="conferences-block" className="conferences-block">
                        <h2>UPCOMING CONFERENCES & EVENTS</h2>
                            <div className="view-conferences">                       
                                <ul className="colistitem">
                                {conferences.map((conf, index) => (
                                    <li
                                    key={index}
                                    className="views-row"
                                    >
                                    <div className="views-field">
                                        <div className="desktop_conference_tile">
                                        <div className="views-field-field-image">
                                            <a href={conf.link}>
                                            <img src={conf.image} alt={conf.title} />
                                            </a>
                                        </div>
                                        <div className="views-field-wrap">
                                            <div className="views-field-title">
                                            <a href={conf.link}>{conf.title}</a>
                                            </div>
                                            <div className="views-field-field-apply-form-desc intro">
                                            {conf.description}
                                            </div>
                                            <div className="views-field-field_location">
                                            <a href={`${configData.RSMWW_URL}/winter-baseball-meetings-career-conference`}>{conf.location}</a>
                                            </div>
                                        </div>
                                     <div className="views-field views-field-field-registration-deadline-day"> 
                                        <div className="rdt">
                                            <span className="a1">{conf.month}</span>
                                            <span className="a2">
                                            {conf.day}
                                            <span className="view-field-year">{conf.year}</span>
                                            </span>
                                            <span className="a3">Conference</span>
                                            <span className="a4">Start Date</span>
                                        </div>

                                        <div className="rbt">
                                            <a href={conf.link}>
                                            <span className="a1_conf">LEARN MORE</span>
                                            </a>
                                        </div>
                                        </div>
                                        </div>

                                        <div className="mobile_conference_tile">
                                       
                                        <div className="views-field-wrap">

                                        <div className="header_title_div">
                                            <div className="circle_image">
                                                <i>
                                                    <img src={conf.icon} alt="icon" />
                                                </i>
                                            </div>

                                            <div className="views-field-title title">
                                                <a href={conf.link}>{conf.title}</a>
                                            </div>
                                        </div>

                                        <div className="rdt">
                                            <div className="month_day">{conf.fullDate}</div>
                                            <div className="starts">{conf.location}</div>
                                            <div className="description">{conf.description}</div>

                                            <div style={{ paddingBottom: "8%", paddingTop: "8%" }}>
                                                <span className="learn-more-btn">
                                                    <a href={conf.link}>LEARN MORE</a>
                                                </span>
                                            </div>
                                        </div>

                                    </div>

                                        </div>
                                    </div>
                                    </li>
                                ))}
                                </ul>
                           
                        </div>
                        </div>
                    </div>
                </div>
                <div className="right">
                       {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default FootballEducationProgram;